export default __webpack_public_path__ + "static/media/zoom.87189808.png";